<template>
  <div class="statistics-personal-page">
    <div class="toolbar">
      <div class="title-block">
        <h1>Статистика: персональная</h1>
      </div>
    </div>

    <div class="state-block">
      Раздел в разработке — персональная статистика логистов появится здесь позже.
    </div>
  </div>
</template>

<script>
export default {
  name: 'PersonalStatisticsPage',
};
</script>

<style scoped>
.statistics-personal-page {
  display: flex;
  flex-direction: column;
  height: 100%;
  padding: 20px;
  padding-bottom: 40px;
}

.toolbar {
  margin-bottom: 16px;
  flex-shrink: 0;
}

.title-block h1 {
  font-size: 22px;
  font-weight: 600;
}

.state-block {
  display: flex;
  align-items: center;
  justify-content: center;
  flex: 1;
  border: 1px solid #e5e7eb;
  border-radius: 8px;
  background: #f9fafb;
  color: #6b7280;
  font-size: 15px;
}
</style>
